/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import * as dc from '@/lib/dc';
import { IconButton, Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function StrategiesView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {' '}
        <div> </div> <div style={{ flex: '1' }}></div>{' '}
        <div style={{ display: 'flex', gap: '8px' }}>
          {' '}
          <button
            onClick={m.stratRecalc}
            aria-label="Re-read strategy stats from the ledger"
            className="scp-2223d55"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              padding: '7px 14px',
              borderRadius: '99px',
              border: '1px solid var(--l12)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-arrows-clockwise" style={{ fontSize: '12px' }}></i>Recalc Stats
          </button>{' '}
          <button
            onClick={m.stratNew}
            aria-label="Create a new strategy"
            className="scp-84a7026"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
              background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
              color: 'var(--acc)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-plus" style={{ fontSize: '12px' }}></i>New Strategy
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        {' '}
        <div style={{ textAlign: 'center', flex: 'none' }}>
          <div
            style={{
              fontSize: '22px',
              fontWeight: '600',
              color: 'var(--neg)',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            0%
          </div>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: 'var(--faint)',
              fontWeight: '600',
              marginTop: '2px',
            }}
          >
            Compliance
          </div>
        </div>{' '}
        <div style={{ width: '1px', alignSelf: 'stretch', background: 'var(--l8)' }}></div>{' '}
        <div>
          {' '}
          <div style={{ fontSize: '12.5px', fontWeight: '500' }}>
            0 of 17 trades tagged to a strategy in the last 30 days
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted2)', marginTop: '4px' }}>
            {'17 untagged trades — tag them directly from the '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                m.goTradeHub?.();
              }}
            >
              TradeHub History
            </a>
            {', '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                m.goTrades?.();
              }}
            >
              Trade Log
            </a>
            {', or '}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                m.goJournal?.();
              }}
            >
              Journal
            </a>
            {' to improve your score.'}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(340px,1fr))', gap: '12px' }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
            display: 'flex',
            flexDirection: 'column',
            gap: '11px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
            {' '}
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '8px',
                background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                border: '1px solid color-mix(in srgb, var(--acc-fill) 25%, transparent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
              }}
            >
              <i className="ph ph-lightning" style={{ fontSize: '15px', color: 'var(--acc-2)' }}></i>
            </div>{' '}
            <div style={{ flex: '1', minWidth: '0' }}>
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>OB reaction entry</div>
              <div
                style={{
                  fontSize: '10.5px',
                  color: 'var(--muted2)',
                  marginTop: '2px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Entries at flip zones or order blocks where the market reverses.
              </div>
            </div>{' '}
            <Toggle
              trackBg={m.stratOb?.trackBg}
              knobBg={m.stratOb?.knobBg}
              knob={m.stratOb?.knob}
              onClick={m.stratOb?.toggle}
              aria-label="Toggle"
            />{' '}
          </div>{' '}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {' '}
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              M1
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              M5
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              M15
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              London
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              New York
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                color: 'var(--acc-2)',
              }}
            >
              XAUUSD
            </span>{' '}
          </div>{' '}
          <div
            style={{
              background: 'transparent',
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              padding: '4px 12px',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Trades Tagged</span>
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>98</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Win Rate</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--neg)' }}>46.9%</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Avg P&L</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--pos)' }}>+$57.88</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Required R:R</span>
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>3:1 min</span>
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {' '}
            <span
              style={{
                fontSize: '10px',
                fontWeight: '500',
                padding: '3px 10px',
                borderRadius: '99px',
                background: 'color-mix(in srgb, var(--acc-fill) 14%, transparent)',
                color: 'var(--acc-2)',
              }}
            >
              Active
            </span>{' '}
            <span
              style={{
                fontSize: '10px',
                padding: '3px 10px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              Price Action
            </span>{' '}
            <span
              style={{
                fontSize: '10px',
                padding: '3px 10px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              Scalp
            </span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <IconButton
              icon="ph-pencil-simple"
              hoverClass="scp-4f3e86a"
              aria-label="Edit (not available — this card is the design package's reference render)"
              aria-describedby="pf-strategy-ref-note"
              disabled
              title="This card is the package's reference render — strategies you create carry live Edit"
            />{' '}
            <IconButton
              icon="ph-trash"
              hoverClass="scp-4f3e86a"
              aria-label="Delete (not available — this card is the design package's reference render)"
              aria-describedby="pf-strategy-ref-note"
              disabled
              title="This card is the package's reference render — strategies you create carry live Archive"
            />{' '}
            <IconButton
              icon="ph-caret-right"
              hoverClass="scp-4f3e86a"
              aria-label="Open (not available — the strategy detail view is not in this build)"
              aria-describedby="pf-strategy-detail-note"
              disabled
              title="The strategy detail view is not in this build"
            />{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
            display: 'flex',
            flexDirection: 'column',
            gap: '11px',
          }}
        >
          {' '}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
            {' '}
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '8px',
                background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                border: '1px solid color-mix(in srgb, var(--acc-fill) 25%, transparent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 'none',
              }}
            >
              <i className="ph ph-sun-horizon" style={{ fontSize: '15px', color: 'var(--acc-2)' }}></i>
            </div>{' '}
            <div style={{ flex: '1', minWidth: '0' }}>
              <div style={{ fontSize: '12.5px', fontWeight: '500' }}>London breakout</div>
              <div
                style={{
                  fontSize: '10.5px',
                  color: 'var(--muted2)',
                  marginTop: '2px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                Breakout of the Asian range in the first hour of London.
              </div>
            </div>{' '}
            <Toggle
              trackBg={m.stratLdn?.trackBg}
              knobBg={m.stratLdn?.knobBg}
              knob={m.stratLdn?.knob}
              onClick={m.stratLdn?.toggle}
              aria-label="Toggle"
            />{' '}
          </div>{' '}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {' '}
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              M15
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              H1
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted)',
              }}
            >
              London
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                color: 'var(--acc-2)',
              }}
            >
              EURUSD
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 8px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                color: 'var(--acc-2)',
              }}
            >
              GBPUSD
            </span>{' '}
          </div>{' '}
          <div
            style={{
              background: 'transparent',
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              padding: '4px 12px',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Trades Tagged</span>
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>41</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Win Rate</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--pos)' }}>58.5%</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
                borderBottom: '1px solid var(--l5)',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Avg P&L</span>
              <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--pos)' }}>+$112.40</span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '6px 0',
                fontSize: '11.5px',
              }}
            >
              <span style={{ color: 'var(--muted2)' }}>Required R:R</span>
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>2:1 min</span>
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {' '}
            <span
              style={{
                fontSize: '10px',
                fontWeight: '500',
                padding: '3px 10px',
                borderRadius: '99px',
                border: '1px solid var(--l12)',
                color: 'var(--muted2)',
              }}
            >
              Paused
            </span>{' '}
            <span
              style={{
                fontSize: '10px',
                padding: '3px 10px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                color: 'var(--muted2)',
              }}
            >
              Breakout
            </span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <IconButton
              icon="ph-pencil-simple"
              hoverClass="scp-4f3e86a"
              aria-label="Edit (not available — this card is the design package's reference render)"
              aria-describedby="pf-strategy-ref-note"
              disabled
              title="This card is the package's reference render — strategies you create carry live Edit"
            />{' '}
            <IconButton
              icon="ph-trash"
              hoverClass="scp-4f3e86a"
              aria-label="Delete (not available — this card is the design package's reference render)"
              aria-describedby="pf-strategy-ref-note"
              disabled
              title="This card is the package's reference render — strategies you create carry live Archive"
            />{' '}
            <IconButton
              icon="ph-caret-right"
              hoverClass="scp-4f3e86a"
              aria-label="Open (not available — the strategy detail view is not in this build)"
              aria-describedby="pf-strategy-detail-note"
              disabled
              title="The strategy detail view is not in this build"
            />{' '}
          </div>{' '}
        </div>{' '}
        {(m.stratCards ?? []).map((r) => (
          <div
            key={String(r['id'])}
            data-strategy-card=""
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              flexDirection: 'column',
              gap: '11px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
              {' '}
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '8px',
                  background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                  border: '1px solid color-mix(in srgb, var(--acc-fill) 25%, transparent)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 'none',
                }}
              >
                <i className="ph ph-strategy" style={{ fontSize: '15px', color: 'var(--acc-2)' }}></i>
              </div>{' '}
              <div style={{ flex: '1', minWidth: '0' }}>
                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(r['name'])}</div>
                <div
                  style={{
                    fontSize: '10.5px',
                    color: 'var(--muted2)',
                    marginTop: '2px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {dc.t(r['desc'])}
                </div>
              </div>{' '}
              <Toggle
                trackBg={dc.s(r['trackBg'])}
                knobBg={dc.s(r['knobBg'])}
                knob={dc.s(r['knob'])}
                onClick={r['toggle'] as () => void}
                aria-label={(r['on'] ? 'Pause ' : 'Activate ') + String(r['name'])}
                aria-pressed={!!r['on']}
              />{' '}
            </div>{' '}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
              {' '}
              {((r['chips'] as string[]) ?? []).map((chip) => (
                <span
                  key={chip}
                  style={{
                    fontSize: '9.5px',
                    padding: '2px 8px',
                    borderRadius: '99px',
                    border: '1px solid var(--l10)',
                    color: 'var(--muted)',
                  }}
                >
                  {chip}
                </span>
              ))}{' '}
            </div>{' '}
            <div style={{ display: 'flex', gap: '14px', fontSize: '11px', color: 'var(--text-mid)' }}>
              <span>
                Trades <b style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(r['statTrades'])}</b>
              </span>
              <span>
                Win <b style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(r['statWin'])}</b>
              </span>
              <span>
                Exp <b style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(r['statExp'])}</b>
              </span>
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {' '}
              <div style={{ flex: '1' }}></div>{' '}
              <IconButton
                icon="ph-pencil-simple"
                hoverClass="scp-4f3e86a"
                aria-label={'Edit ' + String(r['name'])}
                onClick={r['edit'] as () => void}
              />{' '}
              <IconButton
                icon="ph-trash"
                hoverClass="scp-4f3e86a"
                aria-label={'Archive ' + String(r['name'])}
                onClick={r['archive'] as () => void}
              />{' '}
            </div>{' '}
          </div>
        ))}{' '}
      </div>
      <span hidden id="pf-strategy-ref-note">
        This card is the design package's reference render — strategies you create carry live Edit and
        Archive.
      </span>
      <span hidden id="pf-strategy-detail-note">
        The strategy detail view is not in this build.
      </span>
    </div>
  );
}
